export const PUBLIC_TEMPLATES = 'PUBLIC_TEMPLATES'
export const PUBLIC_TEMPLATES_PENDING = 'PUBLIC_TEMPLATES_PENDING'
export const PUBLIC_TEMPLATES_FULFILLED = 'PUBLIC_TEMPLATES_FULFILLED'
export const PUBLIC_TEMPLATES_REJECTED = 'PUBLIC_TEMPLATES_REJECTED'
